/* eslint-disable camelcase */
export const DISCOVERY_DOCUMENT = 'discovery_document';
export const STALE_DISCOVERY_DOC_AGE = 1000 * 60 * 60 * 24 * 5; // 5 days

export interface DiscoveryDocument {
  authorization_endpoint: string;
  token_endpoint: string;
  end_session_endpoint: string;
  revocation_endpoint: string;
  issuer: string;
}

export const buildDiscoveryDocKey = (clientId: string) => [DISCOVERY_DOCUMENT, clientId].join(':');

export const isDiscoveryDocument = (
  data: Partial<DiscoveryDocument>,
): data is DiscoveryDocument => {
  const casted = data as DiscoveryDocument;
  const hasAuth = typeof casted.authorization_endpoint === 'string';
  const hasToken = typeof casted.token_endpoint === 'string';
  const hasEndSession = typeof casted.end_session_endpoint === 'string';
  const hasIssuer = typeof casted.issuer === 'string';
  return hasAuth && hasToken && hasIssuer && hasEndSession;
};
